/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { SecretName } from "./SecretName";
import { SecretValue } from "./SecretValue";
import { EnvironmentId } from "../../commons/types/EnvironmentId";
import { SpaceId } from "../../commons/types/SpaceId";
import { ActorIdUnion } from "../../commons/types/ActorIdUnion";
export const WriteSecret = core.serialization.object({
    name: SecretName,
    value: SecretValue,
    environmentId: EnvironmentId.optional(),
    spaceId: SpaceId.optional(),
    actorId: ActorIdUnion.optional(),
});
